import React from 'react';
import { useData } from '../../contexts';
import { Grid } from '@mui/material';
import { scrollToRef } from '../../utils/utils';

import {
  MdArrowCircleDown,
  MdArrowDownward,
  MdArrowUpward,
  MdArrowDropUp,
  MdArrowCircleUp,
  MdVerticalAlignCenter,
  MdVerticalAlignTop,
} from 'react-icons/md';

export const ArrowNavigation = (props: any) => {
  const { up, down, current, top } = props;
  const { interfaceColor } = useData();

  return (
    <Grid
      item
      xs={12}
      style={{
        fontSize: '3.6rem',
        color: interfaceColor,
        position: 'absolute',
        bottom: '0px',
        right: '20px',
        zIndex: '3',
      }}
    >
      <MdVerticalAlignCenter
        title="Centreer pagina"
        onClick={() => scrollToRef(current)}
        style={{
          paddingRight: '16px',
          cursor: 'pointer',
        }}
      />
      {up !== null ? (
        <MdArrowUpward
          title="Ga naar de vorige sectie"
          onClick={() => {
            scrollToRef(up);
          }}
          style={{
            // borderRadius: '50%',
            // animation: 'pulse 2s infinite',
            cursor: 'pointer',
          }}
        />
      ) : (
        <MdArrowUpward
          style={{
            visibility: 'hidden',
          }}
        />
      )}

      {down !== null ? (
        <MdArrowDownward
          title="Ga naar de volgende sectie"
          onClick={() => scrollToRef(down)}
          style={{
            // borderRadius: '50%',
            // animation: 'pulse 2s infinite',
            cursor: 'pointer',
          }}
        />
      ) : (
        <MdArrowDownward
          style={{
            visibility: 'hidden',
          }}
        />
      )}

      {top !== undefined && top !== null ? (
        <MdVerticalAlignTop
          title="Ga terug naar de top van de pagina"
          onClick={() => scrollToRef(top)}
          style={{
            // borderRadius: '50%',
            // animation: 'pulse 2s infinite',
            cursor: 'pointer',
          }}
        />
      ) : (
        <MdVerticalAlignTop
          style={{
            visibility: 'hidden',
          }}
        />
      )}
    </Grid>
  );
};
